import { Button, Form, Modal } from "antd"
import { Store } from "antd/lib/form/interface"
import React from "react"
import { useTranslation } from "react-i18next"
import ChangeHistoryForm from "~Components/forms/changeHistory.form"
import { NotificationService } from "~Shared/services"
import ExportService from "~Shared/services/export.service"
import { NotificationTypeEnum } from "~Shared/services/notification.service"
import useStateIfMounted from "~Shared/utils/hooks/useStateIfMounted"

const ChangeHistoryModal = ({ isShowing, onCancel }: { isShowing: boolean; onCancel: () => void }) => {
    const { t } = useTranslation()
    const [formInstance] = Form.useForm()
    const [isLoading, setIsLoading] = useStateIfMounted<boolean>(false)

    const handleSubmit = async (values: Store) => {
        setIsLoading(true)
        const { changeHistoryPeriod, resource } = values
        const [startDate, endDate] = changeHistoryPeriod

        try {
            await ExportService.exportChangeHistory({ resource, startDate, endDate })
            onCancel()
            NotificationService.send(NotificationTypeEnum.SUCCESS, t("notification:change_history_export.start.title"), t("notification:change_history_export.start.message"), 0)
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:change_history.export.title"), t("error:change_history.export.message"))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            destroyOnClose
            afterClose={() => formInstance.resetFields()}
            visible={isShowing}
            maskClosable
            title={`${t("label:change_history")}`}
            onCancel={onCancel}
            closable
            keyboard
            className="ant-modal--small"
            footer={[
                <Button key="back" onClick={onCancel}>
                    {t("action:cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={isLoading}
                    onClick={() => {
                        formInstance.submit()
                    }}
                >
                    {t("action:download")}
                </Button>,
            ]}
        >
            <ChangeHistoryForm formInstance={formInstance} onSubmit={handleSubmit} />
        </Modal>
    )
}

export default ChangeHistoryModal
